import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { ZenSnackbarService, ZenSnackBarTypes } from 'src/app/shared/Theme/services/zen-snackbar.service';
import { MiscellaneousService } from '../../../core/services/miscellaneous.service';
import { LoaderService } from '../../../core/services/loader.service';
import { ModuleName } from 'src/app/shared/enums/ModuleName';
import { TranslatePipe } from 'src/app/shared/pipes/translate.pipe';
import { ChildrenAnimation, fadeUpDown } from 'src/app/shared/animations/allAnimations';
import { RespondentService } from 'src/app/core/services/respondent.service';
import { EngagementRespondent } from 'src/app/core/data-models/engagement-respondent';
import { LandingParamsResponse, SecureLandingService } from '@ex/module/core/services/secure-landing.service';
import { products } from '@ex/module/core/data-models/company-permission';
import { LandingForm } from '@ex/module/shared/questionnaire/shared-landing/shared-landing.component';
import { EngagementService } from '@ex/module/core/services/engagement.service';
declare var $: any;
@Component({
  selector: 'app-engagement-landing-page',
  templateUrl: './engagement-landing-page.component.html',
  styleUrls: ['./engagement-landing-page.component.scss'],
  animations: [fadeUpDown, ChildrenAnimation],
  providers: [SecureLandingService],
})
export class EngagementLandingPageComponent implements OnInit {
  private subscriptions = new Subscription();
  referenceKey: string;
  secureLandingRequest$: Observable<LandingParamsResponse>;
  loader: boolean;
  valid: boolean;
  secureLandingFailed: boolean;


  constructor(private route: ActivatedRoute, private miscellanous: MiscellaneousService,
    private router: Router, public loaderService: LoaderService, private zenSnackBarService: ZenSnackbarService, private translationPipe: TranslatePipe,
    private respondentService: RespondentService, private secureLandingService: SecureLandingService, private engagementService: EngagementService) {

  }


  ngOnInit(): void {

    this.referenceKey = this.route.snapshot.paramMap.get('refKey');
    localStorage.setItem('LandingKey', this.referenceKey);

    this.secureLandingRequest$ = this.secureLandingService.specialLandingParams(this.referenceKey, products.Engagement);
  }


  async onSubmit(event: { params: LandingParamsResponse, form: LandingForm, language: string }) {
    const [params, form, language] = [event.params, event.form, event.language];
    let request = {
      name: form.name, employeeID: form.id, email: form.email,
      referenceKey: this.referenceKey
    };
    this.loader = true;
    if (params?.isSecureLanding) {
      this.subscriptions.add(this.engagementService.getSecureRespondentLink(params.tenantKey, params.companyKey, params.surveyKey, request.email, request.employeeID).subscribe(data => {
        this.loader = false;
        if (data.response != 'SUCCESS')
          return this.secureLandingFailed = true;
        this.router.navigate([data?.Data?.link]);
      }))
    }
    else {

      var settings = this.decodeRef(this.referenceKey);

      let respondentRequest = {
        SurveyType: "ENG",
        TenantKey: settings.tenantKey,
        CompanyKey: settings.companyKey,
        SurveyKey: settings.surveyKey,
        FilterByMetrics: [{
          key: 'EmployeeId',
          value: request.employeeID
        }]
      }

      var response = await this.respondentService.fetchSurveyRespondets(respondentRequest).toPromise();

      if (response['Data'].length) {
        const existingRespondent = response['Data'][0];
        let UpdateRequest = {
          SurveyType: "ENG",
          TenantKey: settings.tenantKey,
          CompanyKey: settings.companyKey,
          SurveyKey: settings.surveyKey,
          fromLanding: true,
          respondents: [existingRespondent]
        }

        const res: any = await this.respondentService.updateSurveyRespondent(UpdateRequest).toPromise();

        if (res.response == 'SUCCESS') {
          localStorage.setItem('LandingPageRef', existingRespondent.referenceKey);

          const token = `${"ZENEC-" + btoa(`${settings.tenantKey}#SP#${settings.companyKey}#SP#${settings.surveyKey}#SP#${existingRespondent.ID}`)}`;

          this.router.navigate([
            '/engagement-questionnaire/' + token,
          ]);
        } else if (res.response == 'ERROR_EXISTS') {
          this.loader = false;
          this.zenSnackBarService.snackBar({ message: this.translationPipe.transform('txt_Linkhasal_237', language, ModuleName.Shared), type: ZenSnackBarTypes.Error });
        }

        return;
      }

      this.subscriptions.add(this.miscellanous.createRespondentForLandingPage(request).subscribe((response: any) => {
        if (response.response == 'SUCCESS') {
          let respondent = response.data.respondent;
          let companyName = response.data.companyName;
          let surveyInfo = response.data.surveyInfo;
          let reses: EngagementRespondent[] = [];
          reses.push(respondent);
          let request = {
            SurveyType: "ENG",
            SurveyKey: surveyInfo.key,
            CompanyKey: respondent.companyKey,
            TenantKey: respondent.tenantKey,
            fromLanding: true,
            respondents: reses
          }
          console.log(respondent);
          this.respondentService.updateSurveyRespondent(request).subscribe((response: any) => {
            if (response.response == 'SUCCESS') {
              localStorage.setItem('LandingPageRef', respondent.referenceKey);
              this.router.navigate([
                '/engagement-questionnaire/' + respondent.referenceKey,
              ]);
            } else if (response.response == 'ERROR_EXISTS') {
              this.loader = false;
              this.zenSnackBarService.snackBar({ message: this.translationPipe.transform('txt_Linkhasal_237', language, ModuleName.Shared), type: ZenSnackBarTypes.Error });
            }
          });

        } else {
          if (response.message == 'INSUFFICIENT_FUNDS') {
            this.loader = false;
            this.zenSnackBarService.snackBar({ message: this.translationPipe.transform('txt_Insuffici_313', language, ModuleName.Shared), type: ZenSnackBarTypes.Error });
          }
        }
      }));
    }

  }




  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  decodeRef(ref: string) {
    const [tenantKey, companyKey, surveyKey] = atob(ref).split('#@#');

    return { tenantKey, companyKey, surveyKey };
  }


}
